import { Component, ElementRef, ViewChild } from '@angular/core';
import { ClipboardComponent } from '../clipboard.component';

@Component({
    selector: 'lib-copy-to-clipboard-card',
    templateUrl: './clipboard-card.component.html',
    styleUrls: ['./clipboard-card.component.scss']
})
export class ClipboardCardComponent extends ClipboardComponent {
    @ViewChild('menu', { static: true }) menu!: ElementRef<HTMLElement>;

    hasMenu: boolean = false;

    override ngOnInit() {
        super.ngOnInit();
        this.hasMenu = this.menu.nativeElement.childNodes.length > 0;
    }
}
